import { Component, Inject, OnInit } from "@angular/core"
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog"
import { IconImageService } from "@shared/services/icon-image.service"
import { StateService } from "@shared/services/state.service"
import { ServiceApiService } from "@api/service/service-api.service"

@Component({
  selector: "ag-add-icon-lib",
  templateUrl: "./ag-add-icon-lib.component.html",
  styleUrl: "./ag-add-icon-lib.component.scss",
  standalone: false,
})
export class AgAddIconLibComponent implements OnInit {
  hotelId: string
  title: string
  currentIcon: string
  iconList: string[]
  selectedIcon: string = null
  constructor(
    public serviceApi: ServiceApiService,
    private stateService: StateService,
    public iconService: IconImageService,
    public dialogRef: MatDialogRef<AgAddIconLibComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}
  ngOnInit(): void {
    this.hotelId = this.stateService.selectedHotel.Id
    this.title = this.data.title
    this.currentIcon = this.data.currentIcon
    this.serviceApi.V3HotelAddOn.GetHDIcons().subscribe((x) => {
      this.iconList = x
    })
  }

  public canSave(): boolean {
    return this.selectedIcon !== null
  }

  public save() {
    this.dialogRef.close(this.selectedIcon)
  }

  public selectIcon(icon: string) {
    if (this.currentIcon !== icon) {
      if (icon === this.selectedIcon) {
        this.selectedIcon = null
        return
      }
      this.selectedIcon = icon
    }
  }

  closeDialog(): void {
    this.dialogRef.close()
  }
}
